import { NextResponse } from "next/server";
import type { NextRequest } from "next/server";

export function middleware(request: NextRequest) {
  const { pathname } = request.nextUrl;
  const token = request.cookies.get("sman3oku_lms_session")?.value;

  let session: any = null;
  if (token) {
    try {
      const parts = token.split(".");
      if (parts.length === 3) {
        const payloadJson = Buffer.from(parts[1], "base64").toString("utf8");
        session = JSON.parse(payloadJson);
        if (session.exp && Date.now() >= session.exp * 1000) {
          session = null;
        }
      }
    } catch (e) {
      session = null;
    }
  }

  const isPublicRoute =
    pathname === "/" ||
    pathname === "/login" ||
    pathname.startsWith("/api/auth/login") ||
    pathname.startsWith("/images") ||
    pathname.startsWith("/uploads") ||
    pathname.startsWith("/_next") ||
    pathname.startsWith("/favicon.ico");

  // If trying to access login while already authenticated, redirect to dashboard
  if (pathname === "/login" && session) {
    if (session.role === "ADMIN") {
      return NextResponse.redirect(new URL("/admin/dashboard", request.url));
    }
    if (session.role === "TEACHER") {
      return NextResponse.redirect(new URL("/teacher/dashboard", request.url));
    }
    return NextResponse.redirect(new URL("/student/dashboard", request.url));
  }

  // If accessing protected routes without session, redirect to login
  if (!isPublicRoute && !session) {
    const loginUrl = new URL("/login", request.url);
    loginUrl.searchParams.set("callbackUrl", pathname);
    return NextResponse.redirect(loginUrl);
  }

  // RBAC routing guards
  if (session) {
    if (pathname.startsWith("/admin") && session.role !== "ADMIN") {
      return NextResponse.redirect(
        new URL(session.role === "TEACHER" ? "/teacher/dashboard" : "/student/dashboard", request.url)
      );
    }

    if (pathname.startsWith("/teacher") && session.role !== "TEACHER" && session.role !== "ADMIN") {
      return NextResponse.redirect(new URL("/student/dashboard", request.url));
    }

    if (pathname.startsWith("/homeroom") && !session.isHomeroom && session.role !== "ADMIN") {
      return NextResponse.redirect(
        new URL(session.role === "TEACHER" ? "/teacher/dashboard" : "/student/dashboard", request.url)
      );
    }

    if (pathname.startsWith("/student") && session.role !== "STUDENT" && session.role !== "ADMIN") {
      return NextResponse.redirect(new URL("/teacher/dashboard", request.url));
    }
  }

  return NextResponse.next();
}

export const config = {
  matcher: [
    "/((?!_next/static|_next/image|favicon.ico|.*\\.(?:svg|png|jpg|jpeg|gif|webp)$).*)",
  ],
};
